import { useMutation } from '@tanstack/react-query';

import { getApiHost, getMutationFetchOptions, parseHttpResponse } from '../utils';

export type SerializedCard = {
  address: { id?: number; zip?: string } | null;
  cvv: string | null;
  exp_month: number;
  exp_year: number;
  id: string | null;
  is_visible: boolean | null;
  last_four: string | null;
  number: string | null;
  type: string | null;
  type_id: string;
};

type AddCardParams = {
  userId: string;
  card: SerializedCard;
};

type DeleteCardParams = {
  userId: string;
  cardId: string;
};

export type BillingCard = {
  id: string;
  address?: { id?: number; zip?: string };
  cvv_valid?: boolean;
  exp_month: number;
  exp_year: number;
  is_visible: boolean;
  last_four: string;
  name?: string;
  type: string;
  type_id?: string;
};

export const useAddBillingCardMutation = () =>
  useMutation<BillingCard, Error, AddCardParams>({
    mutationFn: async ({ userId, card }) => {
      const apiHost = getApiHost();
      const url = new URL(`/api/customer/${userId}/billing-card`, apiHost);
      const body = { ...card, preauthorize: true };
      const response = await fetch(url, getMutationFetchOptions('POST', body));
      return parseHttpResponse<BillingCard>(response);
    },
  });

export const useDeleteBillingCardMutation = () =>
  useMutation<void, Error, DeleteCardParams>({
    mutationFn: async ({ userId, cardId }) => {
      const apiHost = getApiHost();
      const url = new URL(
        `/api/customer/${userId}/billing-card/${cardId}`,
        apiHost
      );
      const response = await fetch(url, getMutationFetchOptions('DELETE'));
      if (!response.ok) {
        if (response.status === 403) throw new Error('Not Authorized');
        throw new Error('Error fetching resource');
      }
    },
  });
